(function() {
  'use strict';

  window.TC_updateSSCutline = function(card, cut) {
    if (!card) return;
    
    const cutlineElement = card.querySelector('.product-grid-item__cutline');
    if (cutlineElement && cut) {
      cutlineElement.textContent = cut;
    }
  };

  // Override the problematic upsertProductBadge function
  if (window.upsertProductBadge) {
    const originalUpsertProductBadge = window.upsertProductBadge;
    window.upsertProductBadge = function(params) {
      try {
        // Call the original function but wrap it in try-catch
        return originalUpsertProductBadge.call(this, params);
      } catch (error) {
        console.warn('Error in upsertProductBadge:', error);
        // Fallback: try to handle badges ourselves
        if (params && params.cardInner) {
          const { cardInner, hasCoreBadge, textBadgeValue } = params;
          // Remove old core badges (keep this for safety)
          const oldCores = cardInner.querySelectorAll('.product__badge-core[data-product-badge-core]');
          oldCores.forEach(el => el.remove());
          // Find or create badge container
          let badgeContainer = cardInner.querySelector('.product__badge[data-product-badge]');
          if (!badgeContainer) {
            const imageWrapper = cardInner.querySelector('.product-grid-item__image');
            if (imageWrapper) {
              badgeContainer = document.createElement('div');
              badgeContainer.className = 'product__badge';
              badgeContainer.setAttribute('data-product-badge', '');
              imageWrapper.insertAdjacentElement('afterbegin', badgeContainer);
            }
          }
          if (badgeContainer) {
            // Use helpers to add/update both badges without clearing container
            if (typeof window.upsertTextBadge === 'function') {
              window.upsertTextBadge(badgeContainer, textBadgeValue);
            } else {
              // fallback: add text badge manually if helper not present
              let textBadgeItem = badgeContainer.querySelector('.product__badge__item--custom');
              if (textBadgeValue) {
                if (textBadgeItem) {
                  const span = textBadgeItem.querySelector('span');
                  if (span) {
                    span.textContent = textBadgeValue;
                  } else {
                    textBadgeItem.textContent = textBadgeValue;
                  }
                  textBadgeItem.style.display = '';
                  textBadgeItem.style.visibility = 'visible';
                } else {
                  textBadgeItem = document.createElement('div');
                  textBadgeItem.className = 'product__badge__item product__badge__item--custom';
                  const span = document.createElement('span');
                  span.textContent = textBadgeValue;
                  textBadgeItem.appendChild(span);
                  badgeContainer.insertAdjacentElement('afterbegin', textBadgeItem);
                }
              } else if (textBadgeItem) {
                textBadgeItem.remove();
              }
            }
            if (typeof window.upsertCoreBadge === 'function') {
              window.upsertCoreBadge(badgeContainer, hasCoreBadge);
            } else if (hasCoreBadge && window.getCoreBadgeMarkup) {
              // fallback: add core badge manually if helper not present
              const coreItem = document.createElement('div');
              coreItem.className = 'product__badge__item product__badge-core';
              coreItem.setAttribute('data-product-badge-core', '');
              coreItem.innerHTML = window.getCoreBadgeMarkup();
              badgeContainer.appendChild(coreItem);
            }
          }
        }
      }
    };
  }

  const CORE_BADGE_TAG = 'badge:core-collection';

  function normalizeTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(t => t.toLowerCase());
    if (typeof tags === "string") return tags.split(",").map(t => t.trim().toLowerCase());
    return [];
  }

  function productHasCoreBadgeFromTags(tags) {
    return normalizeTags(tags).includes(CORE_BADGE_TAG);
  }

  function getCoreBadgeMarkup() {
    const source = window.theme?.settings?.core_badge_source;
    const img = window.theme?.settings?.core_badge_image;

    if (source === "image" && img) {
      return `
        <div class="product__core-badge product__badge__item" data-product-core-badge="">
          <img src="${img}" alt="Core Collection" loading="lazy" />
        </div>
      `;
    }

    return `
      <div class="product__core-badge product__badge__item" data-product-core-badge="">
        core collection
      </div>
    `;
  }

  function ensureBadgeContainer(cardInner) {
    let badgeWrapper = cardInner.querySelector(".product__badge");
    if (!badgeWrapper) {
      badgeWrapper = document.createElement("div");
      badgeWrapper.className = "product__badge";
      badgeWrapper.setAttribute("data-product-badge", "");
      cardInner.insertAdjacentElement("afterbegin", badgeWrapper);
    }
    return badgeWrapper;
  }

  function upsertCoreBadge(parentElementOrWrapper, hasCoreBadge) {
    const badgeWrapper = parentElementOrWrapper.querySelector ? parentElementOrWrapper : null;
    if (!badgeWrapper) return;

    let core = badgeWrapper.querySelector(".product__core-badge");

    if (hasCoreBadge) {
      if (!core) {
        core = document.createElement("div");
        core.className = "product__core-badge";
        core.setAttribute("data-product-core-badge", "");
        core.innerHTML = getCoreBadgeMarkup().trim();
        badgeWrapper.appendChild(core.firstElementChild || core);
      }
    } else if (core) {
      core.remove();
    }
  }

  function upsertTextBadge(badgeWrapper, badgeValue) {
    if (!badgeWrapper) return;
    
    // Remove any direct span that doesn't have proper classes
    const directSpan = badgeWrapper.querySelector(":scope > span:not(.product__badge__item)");
    if (directSpan) {
      directSpan.remove();
    }
    
    let textBadgeItem = badgeWrapper.querySelector(".product__badge__item--custom");

    if (badgeValue) {
      if (textBadgeItem) {
        // Update existing badge item
        const span = textBadgeItem.querySelector("span");
        if (span) {
          span.textContent = badgeValue;
        } else {
          textBadgeItem.textContent = badgeValue;
        }
        textBadgeItem.style.display = "";
        textBadgeItem.style.visibility = "visible";
      } else {
        // Create new badge item
        textBadgeItem = document.createElement("div");
        textBadgeItem.className = "product__badge__item product__badge__item--custom";
        const span = document.createElement("span");
        span.textContent = badgeValue;
        textBadgeItem.appendChild(span);
        badgeWrapper.insertAdjacentElement("afterbegin", textBadgeItem);
      }
    } else if (textBadgeItem) {
      textBadgeItem.remove();
    }
  }

  function removeBadgeWrapperIfEmpty(badgeWrapper) {
    // Don't remove the wrapper anymore - keep it for compatibility
    return;
  }

  async function fetchProductData(handle) {
    if (!handle) return null;
    
    let cleanHandle = handle;
    
    if (handle.includes('https://') || handle.includes('http://')) {
      const url = new URL(handle);
      cleanHandle = url.pathname;
    }
    
    cleanHandle = cleanHandle.replace('/products/', '').split('?')[0];

    if (window.ssProductsData[cleanHandle]) {
      return window.ssProductsData[cleanHandle];
    }
    
    try {
      const response = await fetch(`/products/${cleanHandle}.js`);
      if (!response.ok) return null;
      const productData = await response.json();
      window.ssProductsData[cleanHandle] = productData;

      return productData;
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  async function processSSRecommendationItem(item) {
    try {
      if (!item) return;
      
      const innerElement = item.querySelector(".ss__result__inner") || item.querySelector(".card__inner") || item;
      if (!innerElement) return;
      
      const productLink = innerElement.querySelector("a[href*='/products/']");
      if (!productLink) return;
      
      const handle = productLink.getAttribute('href');
      const prodData = await fetchProductData(handle);
      
      if (!prodData) return;
      
      const hasCoreBadge = productHasCoreBadgeFromTags(prodData?.tags);
      
      let badgeValue = "";
      const activeSwatch = innerElement.querySelector(".js-swatch-button[aria-current='true']") ||
                           innerElement.querySelector(".js-swatch-button.is-active") ||
                           innerElement.querySelector(".js-swatch-button");
      
      if (activeSwatch) {
        badgeValue = activeSwatch.getAttribute("data-badge")?.trim() || 
                     activeSwatch.getAttribute("data-badge-text")?.trim() || "";
      }
      
      const badgeContainer = innerElement.querySelector(".product-grid-item__image") || innerElement;
      if (!badgeContainer) return;
      
      let badgeWrapper = badgeContainer.querySelector(".product__badge");
      
      if (badgeValue || hasCoreBadge) {
        badgeWrapper = ensureBadgeContainer(badgeContainer);

        if (badgeWrapper) {
          badgeWrapper.style.display = "";
          badgeWrapper.style.visibility = "visible";
          badgeWrapper.style.opacity = "1";

          upsertTextBadge(badgeWrapper, badgeValue);
          upsertCoreBadge(badgeWrapper, hasCoreBadge);
        }
      }

      // Apply pro pricing if user is a pro customer
      if (window.calculatePriceFromTags && document.body.dataset.pro && prodData.price) {
        const priceEl = innerElement.querySelector('a.product-grid-item__price');
        if (priceEl) {
          const tags = Array.isArray(prodData.tags)
            ? prodData.tags
            : (prodData.tags || '').split(',').map(function(t) { return t.trim(); });
          const priceData = window.calculatePriceFromTags(prodData.price, tags);

          if (priceData.calculatedPrice < priceData.originalPrice) {
            const currencyCode = (window.theme && window.theme.moneyWithCurrencyFormat && window.theme.moneyWithCurrencyFormat.match(/[A-Z]+/g) || ['USD'])[0];
            const formatMoney = function(cents) {
              return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(cents / 100);
            };
            priceEl.innerHTML =
              '<span class="product-grid-item__price-new price">' + formatMoney(priceData.calculatedPrice) + '</span>' +
              '<span class="line-through">' + formatMoney(priceData.originalPrice) + '</span>';
          }
        }
      }

    } catch (error) {
      console.error('Error processing SS recommendation item:', error);
    }
  }

  async function processAllRecommendations() {
    const allItems = document.querySelectorAll('.ss__result__item, .ss__result--item');
    // allItems.forEach(processSSRecommendationItem);
    await Promise.all(Array.from(allItems).map(processSSRecommendationItem));
    
    const delays = [100, 500, 1000];
    for (const delay of delays) {
      await new Promise(resolve => setTimeout(resolve, delay));
      const items = document.querySelectorAll('.ss__result__item, .ss__result--item');
      await Promise.all(Array.from(items).map(processSSRecommendationItem));
    }
  }

  function waitForSearchSpring(callback) {
    let attempts = 0;
    const maxAttempts = 50;
    
    const checkInterval = setInterval(() => {
      attempts++;
      
      const ssRecommendations = document.querySelectorAll('.ss__result__item, .ss__result--item');
      
      if (ssRecommendations.length > 0 || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback();
      }
    }, 100);
  }

  function initializeSSRecommendationsBadges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('ss__result__item') || node.classList?.contains('ss__result--item')) {
              setTimeout(() => processSSRecommendationItem(node), 50);
            }
            
            if (node.classList?.contains('swiper-slide')) {
              const ssResult = node.querySelector('.ss__result--item, .ss__result__item');
              if (ssResult) {
                setTimeout(() => processSSRecommendationItem(ssResult), 50);
              }
            }
            
            if (node.classList?.contains('ss__carousel') && node.classList?.contains('ss__carousel__recommendation')) {
              setTimeout(() => {
                const items = node.querySelectorAll('.ss__result__item, .ss__result--item');
                items.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50); // Stagger processing
                });
              }, 200);
            }
            
            if (node.classList?.contains('ss__tabbed__content')) {
              setTimeout(() => {
                const items = node.querySelectorAll('.ss__result__item, .ss__result--item');
                items.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 300);
            }
            
            const items = node.querySelectorAll?.('.ss__result__item, .ss__result--item');
            items?.forEach((item, index) => {
              setTimeout(() => processSSRecommendationItem(item), index * 50);
            });
            
            const carousel = node.querySelector?.('.ss__carousel.ss__carousel__recommendation');
            if (carousel) {
              setTimeout(() => {
                const carouselItems = carousel.querySelectorAll('.ss__result__item, .ss__result--item');
                carouselItems.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 200);
            }
            
            const tabbedContent = node.querySelector?.('.ss__tabbed__content');
            if (tabbedContent) {
              setTimeout(() => {
                const tabbedItems = tabbedContent.querySelectorAll('.ss__result__item, .ss__result--item');
                tabbedItems.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 300);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Wait for SearchSpring to load before initial processing
    waitForSearchSpring(() => {
      processAllRecommendations();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSSRecommendationsBadges);
  } else {
    initializeSSRecommendationsBadges();
  }
  
  // SearchSpring event handling
  function setupSearchSpringEvents() {
    if (window.SearchSpring?.on) {
      window.SearchSpring.on('afterSearch', () => {
        processAllRecommendations();
      });
      
      // Also listen for recommendation specific events
      window.SearchSpring.on('recommendationsLoaded', () => {
        processAllRecommendations();
      });
    }
  }
  
  if (window.SearchSpring) {
    setupSearchSpringEvents();
  } else {
    // Keep checking for SearchSpring
    let ssCheckInterval = setInterval(() => {
      if (window.SearchSpring) {
        setupSearchSpringEvents();
        clearInterval(ssCheckInterval);
      }
    }, 100);
    
    setTimeout(() => clearInterval(ssCheckInterval), 10000); // 10 seconds max
  }
  
  // Also listen for custom events that SearchSpring might fire
  document.addEventListener('searchspring:recommendations:loaded', () => {
    processAllRecommendations();
  });

  function setupSwatchClickHandlers() {
    document.addEventListener('click', async (event) => {
      const swatch = event.target.closest('.js-swatch-button, .siblings__swatch');
      if (!swatch) return;
      
      const item = swatch.closest('.ss__result--item, .ss__result__item');
      if (!item) return;
      
      const swatchHandle = swatch.getAttribute('href') || swatch.getAttribute('product-handle');
      if (swatchHandle) {
        const prodData = await fetchProductData(swatchHandle);
        if (prodData) {
          const innerElement = item.querySelector(".ss__result__inner") || item.querySelector(".card__inner") || item;
          const badgeContainer = innerElement.querySelector(".product-grid-item__image") || innerElement;
          
          const hasCoreBadge = productHasCoreBadgeFromTags(prodData?.tags);
          const badgeValue = swatch.getAttribute("data-badge")?.trim() || "";
          
          let badgeWrapper = badgeContainer.querySelector(".product__badge");
          
          if (badgeValue || hasCoreBadge) {
            badgeWrapper = ensureBadgeContainer(badgeContainer);
            if (badgeWrapper) {
              upsertTextBadge(badgeWrapper, badgeValue);
              upsertCoreBadge(badgeWrapper, hasCoreBadge);
              removeBadgeWrapperIfEmpty(badgeWrapper);
            }
          } else if (badgeWrapper) {
            badgeWrapper.remove();
          }
        }
      }
    });
  }
  
  setupSwatchClickHandlers();

  window.SSRecommendationsBadges = {
    processSSRecommendationItem,
    productHasCoreBadgeFromTags,
    fetchProductData
  };

})();